import { OutboundTrackingEventData } from '../../../analytics/event-tracking/trackOutboundLinkClick';
import { ClickThroughSourceLocalStorageValue } from '../../../analytics/click-through-tracking/TrackingSource';
import { LinkProps } from '@property.com.au/ui-kit';
import { PCAButtonProps } from '@property.com.au/ui-kit/dist/types/libraries/prop-ui/public/construct-kit/components/Button/Button';
import { IconInfo } from '../ExternalLink/ExternalLink';

export enum DynamicContentName {
  Text = 'Text',
  WebLink = 'WebLink',
  Button = 'Button',
}

export interface IDynamicContent {
  name: DynamicContentName;
}

export type DynamicContents<T extends IDynamicContent> = T[];
export type DynamicContentsItem = DynamicContentText | DynamicContentWebLink | DynamicContentButton;
export type DynamicContentsItems = DynamicContentsItem[];

export interface DynamicContentText extends IDynamicContent {
  __typename: 'Text';
  name: DynamicContentName.Text;
  text: string;
  bold?: boolean | null;
  mark?: boolean | null;
  blur?: boolean | null;
  color?: string | null;
}

export const isDynamicContentText = (
  dynamicContent: DynamicContentsItem,
): dynamicContent is DynamicContentText => {
  return dynamicContent.name === DynamicContentName.Text;
};

export interface DynamicContentWebLink extends IDynamicContent {
  __typename: 'WebLink';
  name: DynamicContentName.WebLink;
  title: string;
  url: string;
  isExternal: boolean;
  variant: LinkProps['variant'];
  iconInfo?: IconInfo | null; // TODO: Move IconInfo interface to types? There are two exported versions of IconInfo - one in ExternalLink and one in WebLink.
  tracking?: {
    outboundTracking: OutboundTrackingEventData | null;
    clickThroughTracking: ClickThroughSourceLocalStorageValue | null;
  };
  rel?: string | null;
  disabled?: boolean | null;
}

export interface DynamicContentButton extends IDynamicContent {
  __typename: 'Button';
  name: DynamicContentName.Button;
  text: string;
  buttonVariant: PCAButtonProps['variant'];
  ariaLabel?: string | null;
  onClick?: () => void;
}
